import {
  DEV_BE_SCOPE,
  DEV_CLIENT_ID,
  QAS_AUTHORITY_DOMAIN,
  QAS_ISSUER_URL,
  QAS_PROFILE_URL,
  QAS_SCOPES,
  QAS_URI
} from '../app/modules/shared/constants/auth.constants';

export const environment = {
  develop: true,
  environment: 'DEV',
  enableProdMode: true,
  backendUrl: 'https://ucid.dev.bbraun.cloud/backend',
  // instana config
  trackingUi: {
    enable: true,
    reportingUrl: '',
    apiKey: ''
  },
  msalConfig: {
    auth: {
      clientId: DEV_CLIENT_ID
    }
  },
  apiConfig: {
    scopes: QAS_SCOPES,
    uri: QAS_URI
  },
  backendApiConfig: {
    scopes: DEV_BE_SCOPE,
    uri: 'https://ucid.dev.bbraun.cloud/backend'
  },
  b2cPolicies: {
    names: {
      signUpSignIn: 'B2C_1A__SIGNUP_SIGNIN_MFA',
    },
    authorities: {
      signUpSignIn: {
        authority: QAS_ISSUER_URL
      },
    },
    authorityDomain: QAS_AUTHORITY_DOMAIN
  },
  profile: QAS_PROFILE_URL
};
